export default function DealSvg({
  color = '#101010',
  backgroundColor = 'transparent',
  width = 20,
  height = 20,
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill={backgroundColor} />
      <path
        d="M8.2 10H11.8M10 8.28571V11.7143M4 8.28571C4.47739 8.28571 4.93523 8.46633 5.27279 8.78782C5.61036 9.10931 5.8 9.54534 5.8 10C5.8 10.4547 5.61036 10.8907 5.27279 11.2122C4.93523 11.5337 4.47739 11.7143 4 11.7143V12.8571C4 13.1602 4.12643 13.4509 4.35147 13.6653C4.57652 13.8796 4.88174 14 5.2 14H14.8C15.1183 14 15.4235 13.8796 15.6485 13.6653C15.8736 13.4509 16 13.1602 16 12.8571V11.7143C15.5226 11.7143 15.0648 11.5337 14.7272 11.2122C14.3896 10.8907 14.2 10.4547 14.2 10C14.2 9.54534 14.3896 9.10931 14.7272 8.78782C15.0648 8.46633 15.5226 8.28571 16 8.28571V7.14286C16 6.83975 15.8736 6.54906 15.6485 6.33474C15.4235 6.12041 15.1183 6 14.8 6H5.2C4.88174 6 4.57652 6.12041 4.35147 6.33474C4.12643 6.54906 4 6.83975 4 7.14286V8.28571Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
